<template>
  <div>
    <!-- 面包屑导航区域 -->    <!-- 卡片视图区域 -->
    <el-card class="box-card">
      <h2>多商户支付和分账功能测试</h2>
      
      <!-- 分账规则测试 -->
      <el-divider content-position="left">分账规则测试</el-divider>
      <el-form :model="splitRuleForm" label-width="120px">
        <el-form-item label="商户ID:">
          <el-input v-model="splitRuleForm.merchantId" placeholder="请输入商户ID"></el-input>
        </el-form-item>
        <el-form-item label="订单类型:">
          <el-select v-model="splitRuleForm.orderType" placeholder="请选择订单类型">
            <el-option label="骑行订单" value="riding"></el-option>
            <el-option label="充值订单" value="recharge"></el-option>
            <el-option label="会员订单" value="membership"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="getSplitRule">获取分账规则</el-button>
        </el-form-item>
      </el-form>
      
      <!-- 分账计算测试 -->
      <el-divider content-position="left">分账计算测试</el-divider>
      <el-form :model="splitCalculateForm" label-width="120px">
        <el-form-item label="订单号:">
          <el-input v-model="splitCalculateForm.orderNo" placeholder="请输入订单号"></el-input>
        </el-form-item>
        <el-form-item label="订单类型:">
          <el-select v-model="splitCalculateForm.orderType" placeholder="请选择订单类型">
            <el-option label="骑行订单" value="riding"></el-option>
            <el-option label="充值订单" value="recharge"></el-option>
            <el-option label="会员订单" value="membership"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="商户ID:">
          <el-input v-model="splitCalculateForm.merchantId" placeholder="请输入商户ID"></el-input>
        </el-form-item>
        <el-form-item label="订单金额:">
          <el-input-number v-model="splitCalculateForm.orderAmount" :precision="2" :step="0.1" :min="0"></el-input-number>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="calculateSplit">计算分账</el-button>
        </el-form-item>
      </el-form>
      
      <!-- 分账执行测试 -->
      <el-divider content-position="left">分账执行测试</el-divider>
      <el-form :model="splitExecuteForm" label-width="120px">
        <el-form-item label="订单号:">
          <el-input v-model="splitExecuteForm.orderNo" placeholder="请输入订单号"></el-input>
        </el-form-item>
        <el-form-item label="订单类型:">
          <el-select v-model="splitExecuteForm.orderType" placeholder="请选择订单类型">
            <el-option label="骑行订单" value="riding"></el-option>
            <el-option label="充值订单" value="recharge"></el-option>
            <el-option label="会员订单" value="membership"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="商户ID:">
          <el-input v-model="splitExecuteForm.merchantId" placeholder="请输入商户ID"></el-input>
        </el-form-item>
        <el-form-item label="订单金额:">
          <el-input-number v-model="splitExecuteForm.orderAmount" :precision="2" :step="0.1" :min="0"></el-input-number>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="executeSplit">执行分账</el-button>
        </el-form-item>
      </el-form>
      
      <!-- 结果显示 -->
      <el-divider content-position="left">测试结果</el-divider>
      <el-card>
        <pre>{{ result }}</pre>
      </el-card>
    </el-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      splitRuleForm: {
        merchantId: '',
        orderType: ''
      },
      splitCalculateForm: {
        orderNo: '',
        orderType: 'riding',
        merchantId: '',
        orderAmount: 0
      },
      splitExecuteForm: {
        orderNo: '',
        orderType: 'riding',
        merchantId: '',
        orderAmount: 0
      },
      result: '测试结果将显示在这里'
    }
  },
  methods: {
    // 获取分账规则
    async getSplitRule() {
      if (!this.splitRuleForm.merchantId || !this.splitRuleForm.orderType) {
        return this.$message.warning('请输入商户ID和订单类型')
      }
      
      try {
        const { data: res } = await this.$http.get(`/split/rule/merchant/${this.splitRuleForm.merchantId}/orderType/${this.splitRuleForm.orderType}`)
        if (res.code !== 200) {
          this.result = `获取分账规则失败: ${res.msg}`
          return this.$message.error(res.msg)
        }
        this.result = `分账规则获取成功:\n${JSON.stringify(res.data, null, 2)}`
        this.$message.success('获取分账规则成功')
      } catch (error) {
        this.result = `获取分账规则异常: ${error.message}`
        this.$message.error('获取分账规则异常')
      }
    },
    
    // 计算分账
    async calculateSplit() {
      if (!this.splitCalculateForm.orderNo || !this.splitCalculateForm.merchantId || this.splitCalculateForm.orderAmount <= 0) {
        return this.$message.warning('请输入完整的分账计算信息')
      }
      
      try {
        const { data: res } = await this.$http.post('/multi/merchant/split/calculate', null, {
          params: this.splitCalculateForm
        })
        if (res.code !== 200) {
          this.result = `计算分账失败: ${res.msg}`
          return this.$message.error(res.msg)
        }
        this.result = `分账计算结果:\n${JSON.stringify(res.data, null, 2)}`
        this.$message.success('计算分账成功')
      } catch (error) {
        this.result = `计算分账异常: ${error.message}`
        this.$message.error('计算分账异常')
      }
    },
    
    // 执行分账
    async executeSplit() {
      if (!this.splitExecuteForm.orderNo || !this.splitExecuteForm.merchantId || this.splitExecuteForm.orderAmount <= 0) {
        return this.$message.warning('请输入完整的分账执行信息')
      }
      
      try {
        const { data: res } = await this.$http.post('/multi/merchant/split/execute', null, {
          params: this.splitExecuteForm
        })
        if (res.code !== 200) {
          this.result = `执行分账失败: ${res.msg}`
          return this.$message.error(res.msg)
        }
        this.result = `分账执行结果:\n${JSON.stringify(res.data, null, 2)}`
        this.$message.success('执行分账成功')
      } catch (error) {
        this.result = `执行分账异常: ${error.message}`
        this.$message.error('执行分账异常')
      }
    }
  }
}
</script>

<style scoped>
.box-card {
  margin: 20px;
}
pre {
  white-space: pre-wrap;
  word-wrap: break-word;
}
</style>